import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { toPipelineRequest, toWebResourceLike } from "../util.js";
import { toCompatResponse, toPipelineResponse } from "../response.js";
/**
 * An enum for compatibility with RequestPolicy
 */

export var HttpPipelineLogLevel;

(function (HttpPipelineLogLevel) {
  HttpPipelineLogLevel[HttpPipelineLogLevel["ERROR"] = 1] = "ERROR";
  HttpPipelineLogLevel[HttpPipelineLogLevel["INFO"] = 3] = "INFO";
  HttpPipelineLogLevel[HttpPipelineLogLevel["OFF"] = 0] = "OFF";
  HttpPipelineLogLevel[HttpPipelineLogLevel["WARNING"] = 2] = "WARNING";
})(HttpPipelineLogLevel || (HttpPipelineLogLevel = {}));

var mockRequestPolicyOptions = {
  log: function log(_logLevel, _message) {
    /* do nothing */
  },
  shouldLog: function shouldLog(_logLevel) {
    return false;
  }
};
/**
 * The name of the RequestPolicyFactoryPolicy
 */

export var requestPolicyFactoryPolicyName = "RequestPolicyFactoryPolicy";
/**
 * A policy that wraps policies written for core-http.
 * @param factories - An array of `RequestPolicyFactory` objects from a core-http pipeline
 */

export function createRequestPolicyFactoryPolicy(factories) {
  var orderedFactories = factories.slice().reverse();
  return {
    name: requestPolicyFactoryPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, next) {
        var httpPipeline, _iterator, _step, factory, webResourceLike, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                httpPipeline = {
                  sendRequest: function () {
                    var _sendRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpRequest) {
                      var response;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return next(toPipelineRequest(httpRequest));

                            case 2:
                              response = _context.sent;
                              return _context.abrupt("return", toCompatResponse(response, {
                                createProxy: true
                              }));

                            case 4:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function sendRequest(_x3) {
                      return _sendRequest2.apply(this, arguments);
                    }

                    return sendRequest;
                  }()
                };
                _iterator = _createForOfIteratorHelper(orderedFactories);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    factory = _step.value;
                    httpPipeline = factory.create(httpPipeline, mockRequestPolicyOptions);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                webResourceLike = toWebResourceLike(request, {
                  createProxy: true
                });
                _context2.next = 6;
                return httpPipeline.sendRequest(webResourceLike);

              case 6:
                response = _context2.sent;
                return _context2.abrupt("return", toPipelineResponse(response));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}